import { Group, Stack, Text } from '@mantine/core';
import dayjs from 'dayjs';
import { i18nKeys, useTranslation } from 'locales';
import type { AutomationLog } from 'modules/Settings/Automation/api';
import { capitalize, isString } from 'remeda';

import type { AutomationModel } from '../../../../AutomationWizard';

import { ResourceAnchor } from './ResourceAnchor';

type AssignRecoveryPlanItemProps = {
  log: AutomationLog;
};

export const AssignRecoveryPlanItem = ({ log }: AssignRecoveryPlanItemProps) => {
  const { t } = useTranslation();

  if (!isString(log.newValue)) return null;

  const modelTypeToKey: Record<AutomationModel, string> = {
    invoice: t(i18nKeys.AUTOMATION.HISTORY_PANEL.ASSIGN_RECOVERY_PLAN.OF_INVOICE),
    debtor: t(i18nKeys.AUTOMATION.HISTORY_PANEL.ASSIGN_RECOVERY_PLAN.OF_CUSTOMER),
  };

  return (
    <Stack gap={2}>
      <Group gap={4}>
        <Text>Le plan de recouvrement</Text>
        <Text fw={600} c="gray.10">
          {log.newValue}
        </Text>
        <Text>{modelTypeToKey[log.model]}</Text>
        <ResourceAnchor log={log} />
      </Group>
      <Text size="sm">{capitalize(dayjs().to(log.date))}</Text>
    </Stack>
  );
};
